var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { SUPPORTED_PREDICATES as PRED } from '../constants/types';
import AddPredicate from './AddPredicate';
import BooleanLiteral from './BooleanLiteral';
import DateTimeLiteral from './DateTimeLiteral';
import FloatLiteral from './FloatLiteral';
import IntegerLiteral from './IntegerLiteral';
import StringLiteral from './StringLiteral';
import PlaceholderLiteral from './PlaceholderLiteral';
import { LOCATION_ATTRIBUTE_UIDS } from '../constants/location';
import LocationsList from './LocationsList';
import LocationsLabels from './LocationsLabels';
import { NODE_ID_NUMERIC_PATTERN } from '../UIJsonParser/transformations';
var RuleRender = function (_a) {
    var _b;
    var condition = _a.condition, uiBlocks = _a.uiBlocks, contextPlugins = _a.contextPlugins, contentInstances = _a.contentInstances, handleExpandToggle = _a.handleExpandToggle, addPredicate = _a.addPredicate, removePredicate = _a.removePredicate, updateUiBlock = _a.updateUiBlock, locationProps = _a.locationProps, contentAnalyticsProps = _a.contentAnalyticsProps, contextLabels = _a.contextLabels, historicalQueries = _a.historicalQueries;
    // predicate constraints map will be used to set how each block is rendered
    var RenderComponent = function (index, uiBlock) {
        var _a, _b;
        var renderProps = {
            logicString: condition,
            isLastBlock: false,
            uiBlock: uiBlock,
            contextPlugins: contextPlugins,
            contentInstances: contentInstances,
            handleExpandToggle: handleExpandToggle,
            removePredicate: removePredicate,
            updateUiBlock: updateUiBlock,
            addPredicate: addPredicate,
            contextLabels: contextLabels,
            historicalQueries: historicalQueries,
            displayId: index.toString(),
        };
        // Handle rules placeholders first
        if (((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.name) || ((_b = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _b === void 0 ? void 0 : _b.contextOrHistorical)) {
            return React.createElement(PlaceholderLiteral, __assign({ key: index }, renderProps));
        }
        // Handle location plugins first
        // because they are independent of the predicate type
        switch (uiBlock.ctxAttributeUid) {
            case LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LIST:
            case LOCATION_ATTRIBUTE_UIDS.PRECISE_LIST:
                return React.createElement(LocationsList, __assign({ key: index, locationProps: locationProps }, renderProps));
            case LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LABELS:
            case LOCATION_ATTRIBUTE_UIDS.PRECISE_LABELS:
                return React.createElement(LocationsLabels, __assign({ key: index, locationProps: locationProps }, renderProps));
        }
        switch (uiBlock.contextParameterType) {
            case PRED.BOOL:
                return React.createElement(BooleanLiteral, __assign({ key: index, contentAnalyticsProps: contentAnalyticsProps }, renderProps));
            case PRED.DATE:
                return React.createElement(DateTimeLiteral, __assign({ key: index, contentAnalyticsProps: contentAnalyticsProps }, renderProps));
            case PRED.FLOAT:
                return React.createElement(FloatLiteral, __assign({ key: index, contentAnalyticsProps: contentAnalyticsProps }, renderProps));
            case PRED.INT:
                return React.createElement(IntegerLiteral, __assign({ key: index, contentAnalyticsProps: contentAnalyticsProps }, renderProps));
            case PRED.STR:
                return React.createElement(StringLiteral, __assign({ key: index, contentAnalyticsProps: contentAnalyticsProps }, renderProps));
        }
        // ToDo: Placeholder UI for any bugs in rule predicates
        return React.createElement(PlaceholderLiteral, __assign({ key: index }, renderProps));
    };
    useEffect(function () {
        uiBlocks.forEach(function (block) {
            if (!Object.values(PRED).includes(block.contextParameterType) && !block.useRaw)
                updateUiBlock(__assign(__assign({}, block), { useRaw: true }));
        });
    }, []);
    var lastUiBlock = uiBlocks[uiBlocks.length - 1];
    var lastUiBlockNodeId = ((_b = lastUiBlock === null || lastUiBlock === void 0 ? void 0 : lastUiBlock.nodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _b === void 0 ? void 0 : _b[0]) || '0';
    var newUiBlockNodeId = String(Number(lastUiBlockNodeId) + (Number(uiBlocks.length - Number(lastUiBlockNodeId)) + 1));
    return (React.createElement(React.Fragment, null,
        uiBlocks && uiBlocks.map(function (uiBlock, index) { return RenderComponent(index + 1, uiBlock); }),
        React.createElement(AddPredicate, { contextPlugins: contextPlugins, newNodeId: newUiBlockNodeId, addPredicate: addPredicate, uiBlocks: uiBlocks })));
};
export default RuleRender;
//# sourceMappingURL=RuleRender.js.map